const viewStoreName = {
	sellerListViewStore: 'sellerListViewStore',
	channelListViewStore: 'channelListViewStore',
	channelEditViewStore: 'channelEditViewStore',
	orderListViewStore: 'orderListViewStore',
	marketplaceOrderListViewStore: 'marketplaceOrderListViewStore',
};

export { viewStoreName };



// WEBPACK FOOTER //
// ./src/common/constants/viewStoreNameConstants.js